import { Box } from '@mui/material';
import CheckGreenIcon from 'assets/images/icons/check-green.svg';
import UnCheckRedIcon from 'assets/images/icons/uncheck-red.svg';

export default function FreeShippingIndicator({ value }) {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
			}}
		>
			{value ? (
				<img src={CheckGreenIcon} alt="Free Shipping" />
			) : (
				<img src={UnCheckRedIcon} alt="Free Shipping" />
			)}
		</Box>
	);
}
